import {createContext} from 'shared/web';

import {DataGridContext} from './DataGridContext';

const [DataGridContextProvider, useDataGridContext] = createContext<DataGridContext>({
  strict: false,
  name: 'DatagridProvider',
});

export {DataGridContextProvider, useDataGridContext};
